import React, { useState } from 'react'
import './styles/section-our-story.css'

const SectionOurStory = () => {
  const [open, setOpen] = useState(false)

  const handleToggle = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setOpen(prev => !prev)
  }

  return (
    <section className="section-our-story comman_sec" id="section-our-story">

      <div className="header-navbar-wrapper">
        <ul className="nav navbar-nav">
          <li className={`dropdown ${open ? 'open' : ''}`}>
            
            {/* ✅ NON-NAVIGATING TOGGLE */}
            <div
              className="dropdown-toggle nav-link"
              role="button"
              tabIndex={0}
              aria-haspopup="true"
              aria-expanded={open}
              onClick={handleToggle}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleToggle(e)
                }
              }}
            >
              Our Story <span className="lnr lnr-chevron-down"></span>
            </div>

            {open && (
              <ul className="dropdown-menu">
                <li>
                  <a href="/about-us">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/our-process">
                    Our Process
                  </a>
                </li>
              </ul>
            )}

          </li>
        </ul>
      </div>
    </section>
  )
}

export default SectionOurStory